module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 0
// module chunks = 20 21